import { Link } from 'react-router-dom'
import ScrollReveal from '@/components/base/ScrollReveal'

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" aria-labelledby="cta-title">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">

        <ScrollReveal direction="up" duration={600}>
          <div className="max-w-2xl mx-auto space-y-4 mb-10">
            <h2 id="cta-title" className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              开启你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              注册即可领取7天免费阅读权益，畅享全站热门作品
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 hover:-translate-y-0.5 hover:shadow-[0_6px_24px_-4px_oklch(var(--primary-500)/0.4)] active:translate-y-0 active:shadow-none transition-all duration-300 whitespace-nowrap cursor-pointer mt-3 group"
            >
              免费开始阅读
              <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={200} duration={600}>
          <div className="relative overflow-hidden rounded-2xl mx-auto group" style={{ height: '120px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20chibi%20characters%20banner%2C%20row%20of%20cute%20mini%20comic%20characters%20lined%20up%20horizontally%2C%20colorful%20and%20playful%20style%2C%20pastel%20background%2C%20sticker%20wall%20aesthetic%2C%20clean%20digital%20illustration%2C%20diverse%20character%20designs%2C%20warm%20and%20inviting%20atmosphere&width=2400&height=240&seq=cta-banner-comics-01&orientation=landscape"
              alt="韩漫角色Q版横幅"
              className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-500 ease-out"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-transparent to-background-50"></div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}